import { render, staticRenderFns } from "./ApproveApplyWindow.vue?vue&type=template&id=764c782e&scoped=true&"
import script from "./ApproveApplyWindow.vue?vue&type=script&lang=js&"
export * from "./ApproveApplyWindow.vue?vue&type=script&lang=js&"
import style0 from "./ApproveApplyWindow.vue?vue&type=style&index=0&id=764c782e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c782e",
  null
  
)

export default component.exports